<template>
  <div v-if="
    config?.HMS?.errorHMS != undefined &&
    (
      config?.HMS?.errorHMS?.dock?.length > 0 ||
      config?.HMS?.errorHMS?.drone?.length > 0
    )
  " :class="classTpl.div" @click.stop.prevent="config.HMS.open = true" :title="$e('Erreur HMS, cliquer pour en savoir plus')">
    <svg class="fill-warning fillPulseWarning" :class="classTpl.svg" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 196.26 169.97">
      <path d="M98.13,0L0,169.97h196.26L98.13,0ZM98.13,20.36l80.49,139.42H17.64L98.13,20.36Z" />
      <rect x="58.94" y="83.08" width="78.38" height="15.37" transform="translate(7.36 188.9) rotate(-90)" />
      <rect x="90.44" y="137.59" width="15.37" height="15.37" transform="translate(-47.15 243.41) rotate(-90)" />
    </svg>
  </div>
</template>
<script>
export default {
  name: "HMS_btn",
  components: {
  },
  props: {
    config: {
      type: Object,
      default: () => { },
    },
    classTpl: {
      type: Object,
      default: () => { },
    },
  },
  setup() {
    return {
    };
  },

};
</script>
